import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { ActDomainManagementVM } from 'civil-status/view-models/act-domain-managment-list';
import { ActValueDomainVM } from 'civil-status/view-models/act-value-domain-managment-list';

export interface TransformDatasetInterface {
  page?: number;
  rowsPerPage?: number;
  actDomainId?: string;
  withoutPagination?: boolean;
}
export const transformDataset = ({
  page = 0,
  rowsPerPage = 10,
  actDomainId,
  withoutPagination = false,
}: TransformDatasetInterface): string => {
  const transformedFilters: OperationObject = {
    idDominio: {
      value: actDomainId || '',
      operation: Operation.EQUALS,
    },
  };

  const paginationObj = {
    ...(!withoutPagination ? { page, rowsPerPage } : {}),
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: {},
    ...paginationObj,
  })}`;
};

export const getFatherDomainNameBasedOnType = (
  list: Array<ActDomainManagementVM>,
  type?: string
): string => {
  return list?.find((item: ActDomainManagementVM) => item?.domainType === type)?.domainName || '';
};

export const getFatherDomainShortDescription = (
  list: Array<ActValueDomainVM>,
  type?: string
): string => {
  return list?.find((item: ActValueDomainVM) => item?.value === type)?.description || '';
};
